import classNames from "classnames/bind";
import { ArtifactSingularProps } from "../../ArtifactSingular";
import { getLinkData, getVideoEmbed } from "@/core/utils";
import { VideoEmbed, Button, Image } from "@components";

import styles from "../../ArtifactSingular.module.scss";
import { useViewSize } from "@/providers/ViewSizeContext";
const cx = classNames.bind(styles);

const ImageRightMobile = (props: ArtifactSingularProps) => {
  const {
    eyebrow,
    artifactSingularHeadline,
    artifactSingularBody,
    image,
    videoEmbed,
    cta,
  } = props;
  const ctaData = getLinkData(cta);
  const showVideoEmbed = getVideoEmbed(videoEmbed) !== null;
  return (
    <>
      <div className={cx("title")}>
        {eyebrow && <p className={cx(["eyebrow-l", "eyebrow"])}>{eyebrow}</p>}
        <h2 className={cx("title-uc-l", "title__lines")}>
          {artifactSingularHeadline.map((line, index) => (
            <span
              key={index}
              className={cx(["line", `title__lines__line-${index}`])}
              dangerouslySetInnerHTML={{ __html: line.line }}
            />
          ))}
        </h2>
      </div>

      {/* Artifact + YouTube combined` */}
      <div className={cx("artifact__imagery")}>
        {/* Artifact */}
        <div className={cx("artifact__artifact")}>
          <Image className={cx("image")} image={image} />
        </div>
        {/* YouTube */}
        {showVideoEmbed && (
          <div className={cx("video")}>
            <VideoEmbed {...videoEmbed} consentSmall={true} />
          </div>
        )}
      </div>

      {/* Body */}
       <div className={cx("body")}>
        {artifactSingularBody.map((line, index) => (
          <div className={cx("body__p-container")} key={index}>
            <p
              className={"text-m"}
              dangerouslySetInnerHTML={{ __html: line.text }}
            />
            {index === artifactSingularBody.length - 1 && ctaData && (
              <Button {...ctaData} />
            )}
          </div>
        ))}
      </div>
    </>
  );
};

const ImageRightDesktop = (props: ArtifactSingularProps) => {
  const {
    eyebrow,
    artifactSingularHeadline,
    artifactSingularBody,
    image,
    videoEmbed,
    cta,
  } = props;
  const ctaData = getLinkData(cta);
  const showVideoEmbed = getVideoEmbed(videoEmbed) !== null;
  return (
    <div className={cx("artifact-singular-image-right__desktop")}>
      <div className={cx(["col-12", "col-lg-6", "copy-col"])}>
        <div className={cx("copy")}>
          <div className={cx("title")}>
            {eyebrow && (
              <p className={cx(["eyebrow-l", "eyebrow"])}>{eyebrow}</p>
            )}
            <h2 className={cx("title-uc-l", "title__lines")}>
              {artifactSingularHeadline.map((line, index) => (
                <span
                  key={index}
                  className={cx(["line", `title__lines__line-${index}`])}
                  dangerouslySetInnerHTML={{ __html: line.line }}
                />
              ))}
            </h2>
          </div>
          <div className={cx("body")}>
            {artifactSingularBody.map((line, index) => (
              <div className={cx("body__p-container")} key={index}>
                <p
                  className={"text-m"}
                  dangerouslySetInnerHTML={{ __html: line.text }}
                />
                {index === artifactSingularBody.length - 1 && ctaData && (
                  <Button {...ctaData} />
                )}
              </div>
            ))}
          </div>
        </div>
        {showVideoEmbed && (
          <div className={cx("video")}>
            <VideoEmbed {...videoEmbed} consentSmall={true} />
          </div>
        )}
      </div>
      <div className={cx(["col-12", "col-lg-6", "artifact-col"])}>
        <div className={cx("artifact__artifact")}>
          <Image className={cx("image")} image={image} />
        </div>
      </div>
    </div>
  );
};

export default function ArtifactImageRight(props: ArtifactSingularProps) {
  const { isTablet, isDesktop } = useViewSize();
  return (
    <>
      <ImageRightDesktop {...props} />
      <ImageRightMobile {...props} />
    </>
  );
}
